import { ServiceTokens } from '../../container/services';
import { type ContainerContext } from '../../container/types';
import { getLogger } from 'loglevel';
import { type CallService } from './interface';
import { PatientCallService } from './patientCall.service';
import { ProviderCallService } from './providerCall.service';
import { type AwilixContainer } from 'awilix';
import { KeyboardShortcutsPlugin } from './plugins/keyboardShortcuts/keyboardShortcutsPlugin';
import { type GenericCallService } from './genericCall.service';
import { BenchmarkPlugin } from './plugins/benchmark/benchmarkPlugin';
import { TimerPlugin } from './plugins/timer/timerPlugin';

type CallServiceFactoryDependencies = {
  $context: ContainerContext;
  $container: AwilixContainer;
};

export const callServiceFactory = ({
  $context,
  $container,
}: CallServiceFactoryDependencies): CallService => {
  let callService: GenericCallService;

  switch ($context) {
    case 'patient': {
      callService = $container.build(PatientCallService, {
        injector: () => ({
          [ServiceTokens.Logger]: getLogger('PatientCallService'),
        }),
      });
      break;
    }
    case 'provider': {
      callService = $container.build(ProviderCallService, {
        injector: () => ({
          [ServiceTokens.Logger]: getLogger('ProviderCallService'),
        }),
      });
      break;
    }
    default: {
      throw new Error('Context for call service factory not provided');
    }
  }

  callService
    .addPlugin<GenericCallService, {}>(new KeyboardShortcutsPlugin())
    .addPlugin<GenericCallService, {}>(
      new BenchmarkPlugin({ cpu: false, gpu: true }),
    )
    .addPlugin<GenericCallService, {}>(new TimerPlugin());

  return callService;
};
